'use strict';

import { ajaxRequest } from '../common/ajax.js'

export var fetchCoachingCompaniesFromServer = function (successCallbacks, errorCallbacks) {
  ajaxRequest({
    url: '/accounts/fetch-coaching-companies/',
    method: 'GET',
    success: successCallbacks,
    expected_response_type: 'json',
    send_as_form_values: true,
  });
}

export var messageCoachingCompany = function (company_id, message, successCallbacks, errorCallbacks) {
  ajaxRequest({
    url: '/accounts/message-company/',
    data: {message: message, company_id: company_id},
    method: 'POST',
    success: successCallbacks,
    send_as_form_values: true,
  });
}
